// extracted by mini-css-extract-plugin
export default {"container":"project_container__SEb6f"};